import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const AliasFilters = ({
  customers,
  selectedCustomerId,
  selectedFieldKey,
  searchTerm,
  onCustomerChange,
  onFieldKeyChange,
  onSearchChange,
  loading,
  hideCustomerFilter = false
}) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="row g-3">
          {/* Customer Filter */}
          {!hideCustomerFilter && (
            <div className="col-md-4">
              <label htmlFor="customerFilter" className="form-label">
                Customer
              </label>
              <select
                id="customerFilter"
                className="form-select"
                value={selectedCustomerId}
                onChange={(e) => onCustomerChange(e.target.value)}
                disabled={loading}
              >
                <option value="">Select a customer...</option>
                {customers.map((customer) => (
                  <option key={customer.id} value={customer.id}>
                    {customer.customerName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Field Key Filter */}
          <div className={hideCustomerFilter ? "col-md-6" : "col-md-4"}>
            <label htmlFor="fieldKeyFilter" className="form-label">
              Field Key
            </label>
            <input
              id="fieldKeyFilter"
              type="text"
              className="form-control"
              placeholder="Filter by field key (e.g., vendor_name)"
              value={selectedFieldKey}
              onChange={(e) => onFieldKeyChange(e.target.value)}
              disabled={loading || !selectedCustomerId}
            />
            <div className="form-text">
              Filter aliases by specific field name
            </div>
          </div>

          {/* Search Filter */}
          <div className={hideCustomerFilter ? "col-md-6" : "col-md-4"}>
            <label htmlFor="searchFilter" className="form-label">
              Search
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <FontAwesomeIcon icon={faSearch} />
              </span>
              <input
                id="searchFilter"
                type="text"
                className="form-control"
                placeholder="Search by original or replacement value..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                disabled={loading || !selectedCustomerId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AliasFilters;
